import { Suspense } from "react";
import "../src/input.css";
import Layout from "./components/Layout/Layout";
import { ConfigProvider } from "antd";

function App() {
  return (
    <Suspense fallback="">
      <ConfigProvider
        theme={{
          token: {
            // Seed Token
            colorPrimary: "#EF4343",
          },
        }}
      >
        <Layout />
      </ConfigProvider>
    </Suspense>
  );
}

export default App;
